import React, { useEffect, useRef, useState } from "react";
import {
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import Carousel from "react-material-ui-carousel";
import "./Template.css";
import { useDispatch } from "react-redux";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  save_content_template_thunk,
  update_content_template_thunk,
  save_media,
} from "./TemplateMaster.Thunk";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import { getAllContents } from "../PedagogySection/Pedagogy.Thunk";
import YouTubeIcon from "@mui/icons-material/YouTube";
import AbcSharpIcon from "@mui/icons-material/AbcSharp";
import Loader from "../../components/Loader";
import DeleteIcon from "@mui/icons-material/Delete";
import DynamicFeedIcon from "@mui/icons-material/DynamicFeed";
// Sun Editor
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { EditorOptions, handleEditorPaste, ensureContentSpacing } from "../../components/EditorOptions";

// MUI
import { Transition } from "../../components/Transition";
import {
  AppBar,
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  TextField,
  Toolbar,
  Typography,
  Modal,
  Box,
  CircularProgress,
  Select,
  MenuItem,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AbcIcon from "@mui/icons-material/Abc";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ImageIcon from "@mui/icons-material/Image";
import BurstModeTwoToneIcon from "@mui/icons-material/BurstModeTwoTone";
import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural";
import CloseIcon from "@mui/icons-material/Close";
import VideoCameraFrontIcon from "@mui/icons-material/VideoCameraFront";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import HearingIcon from "@mui/icons-material/Hearing";
import SaveIcon from "@mui/icons-material/Save";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import AWS from "aws-sdk";
import api from "../../api/api";
import { getMediaUrl } from "../../utils/mediaUtils";
import { deleteFileFromDB, UploadFileToAzureDB } from "../../components/Azure";

function TemplateMaster({ open, params, onClose, contents, setContents }) {
  const [stack, setStack] = useState([]);
  console.log("stack--->", stack);
  const [program, setProgram] = useState(null);
  const [segmentAction, setSegmentAction] = useState("save");
  const [submitAction, setSubmitAction] = useState("save");
  const [openPreview, setOpenPreview] = useState(false);
  const [mediaLoader, setMediaLoader] = useState(null);

  useEffect(() => {
    if (params.trainingType === "training1") setProgram("21st");
    else if (params.trainingType === "training2") setProgram("tech");
    else if (params.trainingType === "training3") setProgram("pedagogy");
    else setProgram(null);
    setStack(params.contentdata ? params.contentdata : []);
    setSubmitAction(params.operation ? params.operation : "save");
  }, [params]);

  const [label, setLabel] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileNameWithExtension, setSelectedFileNameWithExtension] =
    useState(null);
  const [
    selectedFileNameWithoutExtension,
    setSelectedFileNameWithoutExtension,
  ] = useState(null);
  const [selectedFileExtension, setSelectedFileExtension] = useState(null);
  const [selectedFileType, setSelectedFileType] = useState(null);
  console.log("selectedFileType--->", selectedFileType);
  const [selectedFileSize, setSelectedFileSize] = useState(null);
  const videoElemRef = useRef();
  const inputFileRef = useRef();

  let mediatype = "";
  let mediaurl = "";
  let thumburl = "";

  const dispatch = useDispatch();

  const [selectedImage, setSelectedImage] = useState(null);
  const [imageName, setImageName] = useState("");

  const [fileExtensionType, setFileExtensionType] = useState("");
  const [myFile, setMyFile] = useState("");
  console.log("myFile--->", myFile);
  const [fileUrl, setFileUrl] = useState("");
  const [showLinkDialog, setShowLinkDialog] = useState(false);
  const [linkUrl, setLinkUrl] = useState("");
  const [linkText, setLinkText] = useState("");
  const [mediaUploading, setMediaUploading] = useState(false);
  const [youtubeFetching, setYoutubeFetching] = useState(false);
  const [linkAdding, setLinkAdding] = useState(false);
  const [finalSaving, setFinalSaving] = useState(false);
  const [sliderImages, setSliderImages] = useState([]);
  const [sentenceRearrangements, setSentenceRearrangements] = useState([
    { wordValue: "" },
  ]);
  const [type, setType] = useState("");
  console.log("type=========>", type);

  //*-----------------For selecting and displaying the files -----------------
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const maxHeight = 563;
    const maxWidth = 850;
    console.log("file---->", file);
    console.log("mediaType---->", mediaType);

    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const fileType = file.type;

      if (selectedFileType === "image" && file.size > 2097152) {
        toast.error("File size exceeds the maximum allowed (2 MB)");
        return;
      } else if (selectedFileType === "audio" && file.size > 5948300) {
        toast.error("File size exceeds the maximum allowed (4 MB)");
        return;
      } else if (selectedFileType === "video" && file.size > 20971520) {
        toast.error("File size exceeds the maximum allowed (20 MB)");
        return;
      }

      if (fileType.startsWith("video/")) {
        setFileExtensionType("mp4");
        setImageName(`training_${program}_${new Date().getTime()}.mp4`);
        setSelectedFileType("video");

        const videoUrl = URL.createObjectURL(file); // Create a URL for the video file
        setMyFile(videoUrl); // Set the file URL
        setSelectedImage(file); // Set the selected video file
      } else if (fileType.startsWith("audio/")) {
        setFileExtensionType("mp3");
        setImageName(`training_${program}_${new Date().getTime()}.mp3`);
        setSelectedFileType(
          selectedFileType === "text-audio" ? "text-audio" : "audio"
        );
        setMyFile(URL.createObjectURL(file)); // Set the audio file URL
        setSelectedImage(file); // Set the selected audio file
      } else if (fileType.startsWith("image/")) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;

          img.onload = async () => {
            const { width, height } = img;

            if (width > maxWidth || height > maxHeight) {
              toast.error("Maximum height and width exceeded");
              return;
            }

            if (fileExtension === "png" || fileType === "image/png") {
              setFileExtensionType("png");
              setImageName(`training_${program}_${new Date().getTime()}.png`);
              setSelectedFileType(
                selectedFileType === "image"
                  ? "image"
                  : mediaType === "slider/*"
                  ? "slider"
                  : "hotspot"
              );
            } else if (
              fileExtension === "jpg" ||
              fileExtension === "jpeg" ||
              fileType === "image/jpeg"
            ) {
              setFileExtensionType("jpg");
              setImageName(`training_${program}_${new Date().getTime()}.jpg`);
              setSelectedFileType(
                selectedFileType === "image"
                  ? "image"
                  : mediaType === "slider/*"
                  ? "slider"
                  : "hotspot"
              );
            } else {
              console.error("It is neither a PNG nor a JPG file.");
              return;
            }

            setMyFile(e.target.result); // Set the base64 URL for the image
            setSelectedImage(file); // Set the selected image file
          };
        };

        reader.readAsDataURL(file);
      } else if (fileType.startsWith("image/") && mediaType == "slider/*") {
        const reader = new FileReader();

        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;

          img.onload = async () => {
            const { width, height } = img;

            if (width > maxWidth || height > maxHeight) {
              toast.error("Maximum height and width exceeded");
              return;
            }

            if (fileExtension === "png" || fileType === "image/png") {
              setFileExtensionType("png");
              setImageName(`training_${program}_${new Date().getTime()}.png`);
              setSelectedFileType(
                selectedFileType === "image"
                  ? "image"
                  : mediaType === "slider/*"
                  ? "slider"
                  : "hotspot"
              );
              console.log("ImageName--------->", imageName);
            } else if (
              fileExtension === "jpg" ||
              fileExtension === "jpeg" ||
              fileType === "image/jpeg"
            ) {
              setFileExtensionType("jpg");
              setImageName(`training_${program}_${new Date().getTime()}.jpg`);
              setSelectedFileType(
                selectedFileType === "image"
                  ? "image"
                  : mediaType === "slider/*"
                  ? "slider"
                  : "hotspot"
              );
              console.log("ImageName--------->", imageName);
            } else {
              console.error("It is neither a PNG nor a JPG file.");
              return;
            }

            setMyFile(e.target.result); // Set the base64 URL for the image
            setSelectedImage(file); // Set the selected image file
          };
        };

        reader.readAsDataURL(file);
      } else {
        console.error("Unsupported file type");
        return;
      }
    }
  };

  const handleSliderChange = (e) => {
    const files = Array.from(e.target.files);
    const maxImages = 7;
    const maxHeight = 563;
    const maxWidth = 850;

    if (sliderImages.length + files.length > maxImages) {
      toast.error(`You can only upload a maximum of ${maxImages} images`);
      return;
    }

    const newImagePreviews = [...sliderImages];
    let valid = true;

    files.forEach((file, index) => {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const fileType = file.type;

      if (!fileType.startsWith("image/")) {
        toast.error("Unsupported file type");
        valid = false;
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;

        img.onload = () => {
          const { width, height } = img;

          if (width > maxWidth || height > maxHeight) {
            toast.error("Maximum height and width exceeded");
            valid = false;
            return;
          }

          newImagePreviews.push({ src: e.target.result, file });
          console.log("newImagePreviews---------->", newImagePreviews);

          if (index === files.length - 1 && valid) {
            setSliderImages(newImagePreviews);
          }
        };
      };

      reader.readAsDataURL(file);
    });
  };

  const handleRemoveImage = (index) => {
    setSliderImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  //*-------------------For choosing the thumbnail file and name------------
  const thumb_file_on_change = (e) => {
    const file = e.target.files[0];
    // const maxHeight = 1352;
    // const maxWidth = 752;

    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const fileType = file.type;

      if (fileType.startsWith("image/")) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;

          img.onload = async () => {
            const { width, height } = img;

            // if (width > maxWidth || height > maxHeight) {
            //   toast.error("Maximum height and width exceeded");
            //   return;
            // }

            if (fileExtension === "png" || fileType === "image/png") {
              setFileExtensionType("png");
              setThumbName(
                `training_${program}_thumb_${new Date().getTime()}.png`
              );
              // setSelectedFileType("image");
            } else if (
              fileExtension === "jpg" ||
              fileExtension === "jpeg" ||
              fileType === "image/jpeg"
            ) {
              setFileExtensionType("jpg");
              setThumbName(
                `training_${program}_thumb_${new Date().getTime()}.jpg`
              );
              // setSelectedFileType("image");
            } else {
              console.error("It is neither a PNG nor a JPG file.");
              return;
            }

            setThumbnailFile(e.target.result); // Set the base64 URL for the image
            setThumb(file); // Set the selected image file
          };
        };

        reader.readAsDataURL(file);
      } else {
        console.error("Unsupported file type");
        return;
      }
    }
  };

  //*---------To get the url that is sent--------------------
  const openLinkDialog = () => {
    setShowLinkDialog(true);
  };
  const closeLinkDialog = () => {
    setShowLinkDialog(false);
    setLinkUrl("");
    setLinkText("");
  };

  const UrlAdded = (e) => {
    setYoutubeFetching(true);
    setLinkUrl(e.target.value);
    setTimeout(() => {
      setYoutubeFetching(false);
    }, 400);
  };

  //?    Function to add the youTube link in the stack
  const addLinkToStack = () => {
    if (!linkUrl || linkUrl.trim() === "") {
      toast.error("Please add a YouTube link!");
    } else if (linkUrl.startsWith("https://youtu.be/")) {
      setLinkAdding(true);
      const newItem = {
        type: "youtube",
        label: linkText,
        value: linkUrl.split("/")[3],
      };
      setStack((prevStack) => [...prevStack, newItem]);
      setTimeout(() => {
        setLinkAdding(false);
        closeLinkDialog();
      }, 600);
    } else if (linkUrl.startsWith("https://www.youtube.com/watch?v=")) {
      setLinkAdding(true);
      const newItem = {
        type: "youtube",
        label: linkText,
        value: linkUrl.split("/")[3].replace("watch?v=", "").slice(0, 11),
      };
      setStack((prevStack) => [...prevStack, newItem]);
      setTimeout(() => {
        setLinkAdding(false);
        closeLinkDialog();
      }, 600);
    } else {
      toast.error("Please add only YouTube link!");
      // setYoutubeLink(false);
    }
  };

  const editorOnClosee = () => {
    setStack([]);
    onClose();
    getAllContents({ topicId: params.topicid }).then((res) => {
      setContents(res.data);
    });
  };

  //console.log("contents------------------->", contents);
  const videoRef = useRef();

  const editorOnClose = () => {
    setStack([]);
    onClose();
  };
  // -----------------------------------------------------------

  // -------------------------- Text ----------------------------
  const [index, setIndex] = useState(-1);
  const [showTextDialog, setShowTextDialog] = React.useState(false);
  const open_text_dialog = () => {
    setShowTextDialog(true);
  };

  //?------------------------Sentence Rearrangement utilities------------
  const [rearrangeSentenceModal, setRearrangeSetenceModal] = useState(false);
  const [rearrangeSentence, setRearrangeSentence] = useState("");
  const [rearrangeSentenceArray, setRearrangeSentenceArray] = useState([]);

  const open_sentence_rearrangement_modal = () => {
    setRearrangeSetenceModal(true);
  };

  const close_sentence_rearrangement_modal = () => {
    setRearrangeSetenceModal(false);
    setRearrangeSentence("");
    setSentenceRearrangements([{ wordValue: "" }]);
    setType("");
  };

  //^-----Sentence Rearrangement Function to jumble it before saving ------
  // Check if all items in rearrangeSentence have non-empty wordValue
  const hasValidWords = sentenceRearrangements.every(
    (item) => item?.wordValue?.trim() !== ""
  );

  //To add and remove words in case of sentence rearrangement

  const handleAddSentenceRearrangement = () => {
    if (
      sentenceRearrangements[
        sentenceRearrangements.length - 1
      ].wordValue.trim() === ""
    ) {
      toast.error(
        "Please fill the current text field before adding a new one."
      );
      return;
    }

    setSentenceRearrangements([...sentenceRearrangements, { wordValue: "" }]);
  };

  const handleRemoveSentenceRearrangement = (index) => {
    const newSentenceRearrangements = sentenceRearrangements.filter(
      (_, i) => i !== index
    );
    setSentenceRearrangements(newSentenceRearrangements);
  };

  const add_rearrange_sentence_to_stack = () => {
    if (sentenceRearrangements.length === 0 || !hasValidWords) {
      toast.error("Please add a word first!");
    } else if (sentenceRearrangements.length < 5) {
      toast.error("The number of words should be more than 5");
    } else {
      const newItem = {
        label,
        value: sentenceRearrangements,
        type: type,
        thumbnail: "",
      };
      if (segmentAction === "save") {
        setStack((prevStack) => [...prevStack, newItem]);
        close_sentence_rearrangement_modal(); //After saving, I need to close the modal
      } else if (segmentAction === "edit") {
        const updatedStack = stack.map((obj, i) => {
          if (i === index) return { ...obj, label, value: editor1Content };
          return obj;
        });
        setStack(updatedStack);
        setSegmentAction("save");
        setIndex(-1);
      }
      close_text_dialog();
    }
  };

  //?-----------------------------------------------------------------------------------

  const close_text_dialog = () => {
    setLabel("");
    setEditor1Content("");
    setShowTextDialog(false);
    setRearrangeSetenceModal(false);
  };
  const [editor1Content, setEditor1Content] = useState("");
  const texteditor_on_change = (content) => {
    setEditor1Content(content);
  };

  const add_text_to_stack = () => {
    const formattedContent = ensureContentSpacing(editor1Content);
    const newItem = { type: "text", label, thumbnail, value: formattedContent };
    if (segmentAction === "save") {
      setStack((prevStack) => [...prevStack, newItem]);
    } else if (segmentAction === "edit") {
      const updatedStack = stack.map((obj, i) => {
        if (i === index) return { ...obj, label, value: formattedContent };
        return obj;
      });
      setStack(updatedStack);
      setSegmentAction("save");
      setIndex(-1);
    }
    close_text_dialog();
  };

  const edit_stack = (ele, index) => {
    setIndex(index);
    setSegmentAction("edit");
    setLabel(ele.label); // Set the label in the state
    setEditor1Content(ele.value); // Set the content value in the state
    setShowTextDialog(true);
  };

  // --------------------------------------------------------------

  // -------------------------- Media -----------------------------
  const mediaRef = useRef();
  const [showMediaDialog, setShowMediaDialog] = useState(false);
  const [mediaType, setMediaType] = useState("");
  console.log("mediaType=hj===>", mediaType);
  const open_media_dialog = (type, fileType) => {
    console.log("type====>", type);
    setMediaType(type);
    setSelectedFileType(fileType);
    setShowMediaDialog(true);
  };

  const clearInputStates = () => {
    setLabel("");
    setThumbnail("");
    setSelectedFile(null);
    setSelectedFileNameWithExtension(null);
    setSelectedFileNameWithoutExtension(null);
    setSelectedFileExtension(null);
    setSelectedFileType(null);
    setSelectedFileSize(null);
    setSelectedImage(null);
    setMyFile("");
    const fileInput = document.getElementById("fileInput");
    if (fileInput) {
      fileInput.value = "";
    }
  };
  const close_media_dialog = () => {
    clearInputStates(); // Clear input states when closing media dialog
    setShowMediaDialog(false);
    setMyFile("");
    setSelectedImage(null);
    setSelectedFileType(null);
    setImageName("");
    setThumbName("");
    setThumb(null);
    setSliderImages([]);
    setThumbnailFile(null);
    const fileInput = document.getElementById("fileInput");
    if (fileInput) {
      fileInput.value = "";
    }

    const thumbInput = document.getElementById("thumbInput");
    if (thumbInput) {
      thumbInput.value = "";
    }

    setClickPosition({ x: 0, y: 0 });
    setSavedValues([]);
  };

  const [file, setFile] = useState(null);
  const [thumb, setThumb] = useState("");
  const [thumbName, setThumbName] = useState("");
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  //&--------------------To handle video play-----------------------
  const handlePlayVideo = () => {
    setIsVideoPlaying(true);
  };

  //*---------To get the url for the thumbnail is sent--------------------
  const handleThumbnailUpload = async () => {
    try {
      console.log(
        `Selected thumbnail name--> ${thumbName}  and thumbnail file--${thumb}`
      );
      const result = await UploadFileToAzureDB(thumb, thumbName);
      return result.url;
    } catch (error) {
      if (error.response && error.response.status === 413) {
        toast.error("The file is too large to upload");
        console.error("The error is:", error);
      } else {
        console.error("Error fetching modules:", error);
      }
    }
  };

  const [imageUrl, setImageUrl] = useState("");

  const add_media_to_stack = async () => {
    console.log("mediatype1--->", mediaType);
    if (mediaType === "video/*" && !thumb && selectedImage) {
      toast.error("Please choose a thumbnail for the video !");
    } else if (mediaType === "video/*" && !selectedImage && thumb) {
      toast.error("Please choose a video !");
    } else if (mediaType === "video/*" && !selectedImage && !thumb) {
      toast.error("Please choose a video and a thumbnail for it !");
    } else if (mediaType === "hotspot/*" && savedValues?.length === 0) {
      toast.error("Please choose Image and spots !");
    } else if (mediaType === "slider/*" && sliderImages?.length === 0) {
      toast.error("Please choose Image for slider !");
    } else {
      console.log("media---->", mediaType, savedValues);
      setMediaUploading(true);
      console.log(
        `Selected Image name--> ${imageName}  and Image file--${selectedImage}`
      );
      // console.log(
      //   `Selected Image name--> ${thumbName}  and Image file--${thumb}`
      // );

      let uploadResults = [];
      let thumbUrl = "";
      if (mediaType === "slider/*") {
        for (let i = 0; i < sliderImages.length; i++) {
          const { file } = sliderImages[i];
          const fileExtension = file.name.split(".").pop().toLowerCase(); // Define fileExtension
          const newFileName = `training_${program}_${new Date().getTime()}.${fileExtension}`;

          const uploadResult = await UploadFileToAzureDB(file, newFileName); // Use newFileName

          uploadResults.push(
            uploadResult.url
          );
        }
      } else if (mediaType === "hotspot/*") {
        const uploadResult = await UploadFileToAzureDB(
          selectedImage,
          imageName
        );
        uploadResults.push(uploadResult.url || imageName);
        thumbUrl = await handleThumbnailUpload();
      } else {
        const uploadResult = await UploadFileToAzureDB(
          selectedImage,
          imageName
        );
        uploadResults.push(uploadResult.url || imageName);
        if (thumb) {
          thumbUrl = await handleThumbnailUpload();
        }
      }

      console.log("uploadResults-->", uploadResults);

      let newItem;

      if (selectedFileType === "hotspot") {
        newItem = {
          label,
          value: savedValues,
          type: selectedFileType,
          thumbnail: uploadResults[0] || imageName,
        };
      } else if (selectedFileType === "slider") {
        newItem = {
          label,
          value: uploadResults,
          type: selectedFileType,
          thumbnail: "",
        };
      } else {
        newItem = {
          type: selectedFileType,
          label,
          value: uploadResults[0] || imageName,
          thumbnail: thumbUrl || (thumbName ? thumbName : ""),
        };
      }

      console.log("newItem---->", newItem);
      setStack((prevStack) => [...prevStack, newItem]);
      // close_media_dialog();
      clearInputStates();
      getAllContents({ topicId: params.topicid })
        .then((res) => {
          // console.log("getApiCalled");
          if (res.status === 200) {
            setContents(res.data);
            setImageName("");
            const fileInput = document.getElementById("fileInput");
            if (fileInput) {
              fileInput.value = "";
            }
            setImageUrl(uploadResults[0]);
            setSelectedImage(null);
            close_media_dialog();
            setMediaUploading(false);
          } else {
            console.log("Status received----------->", res.status);
            setSelectedImage(null);
            close_media_dialog();
            setMediaUploading(false);
          }
        })
        .catch((err) => {
          if (err.response && err.response.status === 413) {
            toast.error("The file is too large to upload");
            console.error("The error is:", err);
            setSelectedImage(null);
            close_media_dialog();
            setMediaUploading(false);
          } else {
            console.error("Error fetching modules:", err);
            setSelectedImage(null);
            close_media_dialog();
            setMediaUploading(false);
          }
        });
    }
  };

  console.log("imageName------------>");

  const video_file_on_change = (e) => {
    const selectedVideoFile = e.target.files[0];
    if (selectedVideoFile && selectedVideoFile.size <= 100 * 1024 * 1024) {
      // Video file size is within the limit, set it in the state
      setFile(selectedVideoFile);
      if (mediaType === "video/*") {
        setSelectedFileType("video"); // Set the file type to "video"
      } else if (mediaType === "audio/*") {
        setSelectedFileType("audio"); // Set the file type to "audio"
      } else if (mediaType === "image/*") {
        setSelectedFileType("image"); // Set the file type to "image"
      }
    } else {
      // Video file size exceeds the limit, show a toast error or alert
      toast.error("Video file size should be less than 100MB");
      setFile(null); // Clear the selected file
      setSelectedFileType(null); // Clear the selected file type
    }
  };

  const delete_stack = (type, ele, index) => {
    //
    console.log("delete--->", type, ele, index);
    const updatedStack = stack.filter((_, i) => i !== index);
    setStack(updatedStack);

    const deleteFile = (fileUrl) => {
      deleteFileFromDB(fileUrl);
      setShowLoader(true);
      setProgress(0);
      const parsedUrl = new URL(fileUrl);
      const path = parsedUrl.pathname;
      const segments = path.split("/");
      const filename = segments[segments.length - 1];
      console.log("Deleting file:", filename);
    };

    if (type === "media" && ele?.type === "hotspot") {
      deleteFile(ele.thumbnail);
    } else if (ele.type === "slider") {
      ele.value.forEach(deleteFile);
    } else if (ele.type === "youtube") {
    } else if (type === "rearrangement") {
      setStack(updatedStack);
    } else if (type === "puzzle") {
      setStack(updatedStack);
    } else {
      deleteFile(ele.value);
    }
  };

  // --------------------------------------------------------------

  // ----------------------- Save Contennt ------------------------
  const save_content = () => {
    if (stack.length > 0) {
      if (program === "21st") {
        if (submitAction === "save") save_21st();
        else if (submitAction === "update") update_21st();
        else {
          setAlertTitle("Error");
          setAlertText(
            "[Code: 1001] Something went wrong <",
            program,
            "> - <",
            submitAction,
            ">"
          );
        }
      } else if (program === "tech") {
        if (submitAction === "save") save_tech();
        else if (submitAction === "update") update_tech();
        else {
          setAlertTitle("Error");
          setAlertText(
            "[Code: 1002] Something went wrong <",
            program,
            "> - <",
            submitAction,
            ">"
          );
        }
      } else if (program === "pedagogy") {
        if (submitAction === "save") save_pedagogy();
        else if (submitAction === "update") update_pedagogy();
        else {
          setAlertTitle("Error");
          setAlertText(
            "[Code: 1003] Something went wrong <",
            program,
            "> - <",
            submitAction,
            ">"
          );
        }
      } else {
        setAlertTitle("Error");
        setAlertText("[Code: 1004] Something went wrong <", program, ">");
      }
    } else {
      setAlertTitle("Error");
      setAlertText("[Code: 1005] Nothing to save");
      toast.error("Nothing to save");
    }
  };

  const getProcessedStack = () =>
    stack.map((item) =>
      item.type === "text" && item.value
        ? { ...item, value: ensureContentSpacing(item.value) }
        : item
    );

  const save_21st = () => {
    setFinalSaving(true);

    const body = {
      topicId: params.topicid,
      contentData: getProcessedStack(),
    };
    save_content_template_thunk(body).then((data) => {
      if (data && data.status === 200) {
        getAllContents({ topicId: params.topicid }).then((res) => {
          setContents(res.data);
        });
        setAlertTitle("Success");
        setAlertText("Content saved successfully");
        setLabel("");
        setStack([]);
        setFinalSaving(false);
        setShowAlert(true);
        setFileUrl("");
        setOpenPreview(false);
      } else {
        setAlertTitle("Error");
        setAlertText("Content save failed");
        setFinalSaving(false);
        setShowAlert(true);
        setFileUrl("");
        setOpenPreview(false);
      }
    });
  };

  const update_21st = () => {
    setFinalSaving(true);
    const body = {
      topicId: params.topicid,
      contentData: getProcessedStack(),
    };
    update_content_template_thunk(body).then((data) => {
      if (data.status === 200) {
        getAllContents({ topicId: params.topicid }).then((res) => {
          setContents(res.data);
        });
        setAlertTitle("Success");
        setAlertText("Content saved successfully");
        setLabel("");
        setStack([]);
        setFinalSaving(false);
        setShowAlert(true);
        setFileUrl("");
        setOpenPreview(false);
      } else {
        setAlertTitle("Error");
        setAlertText("Content save failed");
        setFinalSaving(false);
        setShowAlert(true);
        setFileUrl("");
        setOpenPreview(false);
      }
    });
  };

  const save_tech = () => {
    setFinalSaving(true);
    const body = {
      topicId: params.topicid,
      contentData: getProcessedStack(),
    };
    save_content_template_thunk(body).then((data) => {
      if (data && data.status === 200) {
        getAllContents({ topicId: params.topicid }).then((res) => {
          setContents(res.data);
        });
        setAlertTitle("Success");
        setAlertText("Content saved successfully");
        setLabel("");
        setStack([]);
        setFinalSaving(false);
        setShowAlert(true);
        setFileUrl("");
        setOpenPreview(false);
      } else {
        setAlertTitle("Error");
        setAlertText("Content save failed");
        setFinalSaving(false);
        setShowAlert(true);
        setFileUrl("");
        setOpenPreview(false);
      }
    });
  };

  const update_tech = () => {
    setFinalSaving(true);
    const body = {
      topicId: params.topicid,
      contentData: getProcessedStack(),
    };
    update_content_template_thunk(body).then((data) => {
      if (data.status === 200) {
        getAllContents({ topicId: params.topicid }).then((res) => {
          setContents(res.data);
        });
        setAlertTitle("Success");
        setAlertText("Content saved successfully");
        setLabel("");
        setStack([]);
        setFinalSaving(false);
        setShowAlert(true);
        setFileUrl("");
        setOpenPreview(false);
      } else {
        setAlertTitle("Error");
        setAlertText("Content save failed");
        setFinalSaving(false);
        setShowAlert(true);
        setFileUrl("");
        setOpenPreview(false);
      }
    });
  };

  const save_pedagogy = () => {
    setFinalSaving(true);
    const body = {
      topicId: params.topicid,
      contentData: getProcessedStack(),
    };

    console.log("save---->", body);
    console.log("stack---->", stack);
    save_content_template_thunk(body).then((data) => {
      if (data && data.status === 200) {
        getAllContents({ topicId: params.topicid }).then((res) => {
          setContents(res.data);
        });
        setAlertTitle("Success");
        setAlertText("Content saved successfully");
        setLabel("");
        setStack([]);
        setFinalSaving(false);
        setShowAlert(true);
        setFileUrl("");
        setOpenPreview(false);
      } else {
        setAlertTitle("Error");
        setAlertText("Content save failed");
        setFinalSaving(false);
        setShowAlert(true);
        setFileUrl("");
        setOpenPreview(false);
      }
    });
  };

  const update_pedagogy = () => {
    setFinalSaving(true);
    const body = {
      topicId: params.topicid,
      contentData: getProcessedStack(),
    };
    update_content_template_thunk(body).then((data) => {
      if (data.status === 200) {
        getAllContents({ topicId: params.topicid }).then((res) => {
          setContents(res.data);
        });
        setAlertTitle("Success");
        setAlertText("Content saved successfully");
        setLabel("");
        setStack([]);
        setFinalSaving(false);
        setShowAlert(true);
        setFileUrl("");
        setOpenPreview(false);
      } else {
        setAlertTitle("Error");
        setAlertText("Content save failed");
        setFinalSaving(false);
        setShowAlert(true);
        setFileUrl("");
        setOpenPreview(false);
      }
    });
  };
  // ---------------------------------------------------------------

  // ------------------------ Alert -------------------------------
  const [showAlert, setShowAlert] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertText, setAlertText] = useState("");
  const open_alert = () => {
    setShowAlert(true);
  };
  const close_alert = () => {
    // editorOnClose();
    onClose();
    setShowAlert(false);
    getAllContents({ topicId: params.topicid }).then((res) => {
      setContents(res.data);
    });
  };
  // ---------------------------------------------------------------

  // ------------------------ Loader -------------------------------
  const [showLoader, setShowLoader] = useState(false);
  const [progress, setProgress] = useState(0);
  // ---------------------------------------------------------------//

  const newVideoStack = stack?.filter((item) => {
    return item.type === "video";
  });

  //Content rearrangement
  const change_stack_position = (index1, index2) => {
    if (
      index1 < 0 ||
      index2 < 0 ||
      index1 >= stack.length ||
      index2 >= stack.length
    )
      return;

    setStack((prevStack) => {
      const newData = [...prevStack];
      // Swap the two entire objects including thumbnail and video source
      const temp = newData[index1];
      newData[index1] = newData[index2];
      newData[index2] = temp;

      console.log("Updated stack with video source:", newData);
      return newData;
    });
  };

  //*-------------------Preview logic--------------------------------
  const openPreviewBox = () => {
    setOpenPreview(true);
  };

  const closePreviewBox = () => {
    setOpenPreview(false);
  };

  function getYouTubeId(url) {
    let videoId = "";
    const regExp = /^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    if (match && match[2].length === 11) {
      videoId = match[2];
    }
    return videoId;
  }

  const [clickPosition, setClickPosition] = useState({ x: 0, y: 0 });

  const [inputValues, setInputValues] = useState({
    spotName: "",
    spotDesc: "",
    xCordinate: 0,
    yCordinate: 0,
  });
  const [savedValues, setSavedValues] = useState([]);

  const [editIndex, setEditIndex] = useState(null);
  const handleHotspotClick = (event) => {
    const rect = event.target.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    // Check if the click position is already selected
    const isPositionSelected = savedValues.some(
      (value) => value.xCordinate === x && value.yCordinate === y
    );

    if (isPositionSelected) {
      alert("This position is already selected.");
      return;
    }

    setClickPosition({ x, y });
    setInputValues((prevValues) => ({
      ...prevValues,
      xCordinate: x,
      yCordinate: y,
    }));
  };

  const handleAddClick = () => {
    const { spotName, spotDesc, xCordinate, yCordinate } = inputValues;

    if (!spotName || xCordinate === 0 || yCordinate === 0) {
      toast.error("Fill in the blanks !");
    } else {
      if (editIndex !== null) {
        const updatedValues = [...savedValues];
        updatedValues[editIndex] = {
          ...inputValues,
          xCordinate: clickPosition.x,
          yCordinate: clickPosition.y,
        };
        console.log("updatedValues1---->", updatedValues);
        setSavedValues(updatedValues);
        setEditIndex(null);
      } else {
        console.log("updatedValues2---->");
        console.log("updatedValues2---->", imageName);
        setSavedValues((prevValues) => [
          ...prevValues,
          {
            ...inputValues,
            xCordinate: clickPosition.x,
            yCordinate: clickPosition.y,
          },
        ]);
        setEditIndex(null);
      }
    }

    // Keep image state intact
    setInputValues({
      spotName: "",
      spotDesc: "",
      xCordinate: 0,
      yCordinate: 0,
    });
    setClickPosition({ x: 0, y: 0 });
  };

  console.log("My image name----------->", imageName);

  const handleInputChange = (event) => {
    const { id, value } = event.target;
    setInputValues((prevValues) => ({ ...prevValues, [id]: value }));
  };

  const handleEditClick = (index) => {
    const valueToEdit = savedValues[index];
    setInputValues(valueToEdit);
    setClickPosition({ x: valueToEdit.xCordinate, y: valueToEdit.yCordinate });
    setEditIndex(index);
  };
  const handleDeleteClick = (index) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      const updatedValues = savedValues.filter((_, i) => i !== index);
      setSavedValues(updatedValues);
    }
  };

  const handleSentenceRearrangementChange = (index, event) => {
    const newSentenceRearrangements = [...sentenceRearrangements];
    // Remove spaces from the input value
    const inputValue = event.target.value.replace(/\s+/g, "").trim();

    newSentenceRearrangements[index].wordValue = inputValue;
    newSentenceRearrangements[index].wordOrder =
      newSentenceRearrangements.length;
    newSentenceRearrangements[index].correctStatus = true;
    newSentenceRearrangements[index].wordId = new Date().getTime();

    setSentenceRearrangements(newSentenceRearrangements);
  };

  const getColorByIndex = (index) => {
    const colors = [
      "#ff9999",
      "#ffb380",
      "#ffff99",
      "#90ee90",
      "#87cefa",
      "#d8bfd8",
      "#c6c6f9",
    ];
    return colors[index % colors.length];
  };

  //---------------------------------------------------------------------------
  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={editorOnClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            {/* <IconButton edge="start" color="inherit" onClick={editorOnClose} aria-label="close">
              <CloseIcon />
            </IconButton> */}
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Content Editor
            </Typography>

            <Button autoFocus color="inherit" onClick={editorOnClosee}>
              <CloseIcon />
            </Button>
          </Toolbar>
        </AppBar>
        <div>
          <div className="add_element_menu">
            <Button onClick={open_text_dialog}>
              <AssignmentIcon />
            </Button>
            <Button onClick={open_sentence_rearrangement_modal}>
              <AbcIcon style={{ height: "40", width: "40" }} />
            </Button>
            <Button onClick={() => open_media_dialog("image/*", "image")}>
              <ImageIcon />
            </Button>
            <Button onClick={() => open_media_dialog("slider/*", "slider")}>
              <BurstModeTwoToneIcon />
            </Button>
            <Button onClick={() => open_media_dialog("hotspot/*", "hotspot")}>
              <FaceRetouchingNaturalIcon />
            </Button>
            <Button onClick={() => open_media_dialog("audio/*", "audio")}>
              <VolumeUpIcon />
            </Button>
            <Button
              onClick={() => open_media_dialog("text-audio/*", "text-audio")}
            >
              <HearingIcon />
            </Button>
            <Button onClick={() => open_media_dialog("video/*")}>
              <VideoCameraFrontIcon />
            </Button>
            <Button onClick={openLinkDialog}>
              <YouTubeIcon />
            </Button>
            <Button onClick={openPreviewBox}>
              <SaveIcon />
            </Button>
            {/* <Button onClick={save_content}>
              <SaveIcon />
            </Button> */}
          </div>
          <div style={{ marginLeft: "-5px" }}>
            {/* Preview */}
            <div className="outer-preview">
              <div className="inner-preview">
                {stack.map((object, index) => (
                  <div key={index} className="preview-card">
                    <div>
                      {object.type === "text" && (
                        <>
                          <div>
                            <Button
                              color="error"
                              onClick={() =>
                                delete_stack("text", object, index)
                              }
                            >
                              <HighlightOffIcon />
                            </Button>
                            <Button onClick={() => edit_stack(object, index)}>
                              <DriveFileRenameOutlineIcon />
                            </Button>
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                change_stack_position(index, index + 1)
                              }
                            >
                              <KeyboardArrowDownIcon />
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                change_stack_position(index, index - 1)
                              }
                            >
                              <KeyboardArrowUpIcon />
                            </IconButton>
                          </div>
                          {object.label}
                          <div
                            dangerouslySetInnerHTML={{
                              __html: object.value,
                            }}
                            style={{ wordWrap: "break-word" }}
                          ></div>
                        </>
                      )}

                      {object.type === "image" && (
                        <>
                          <div>
                            <Button
                              color="error"
                              onClick={() =>
                                delete_stack("media", object, index)
                              }
                            >
                              <HighlightOffIcon />
                            </Button>
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                change_stack_position(index, index + 1)
                              }
                            >
                              <KeyboardArrowDownIcon />
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                change_stack_position(index, index - 1)
                              }
                            >
                              <KeyboardArrowUpIcon />
                            </IconButton>
                          </div>
                          <div>
                            {object.label}
                            {object.value &&
                            object.type === "image" &&
                            submitAction === "save" ? (
                              <img
                                src={getMediaUrl(object.value)}
                                width="90%"
                                alt=""
                              />
                            ) : object.value &&
                              object.type === "image" &&
                              submitAction === "update" ? (
                              <img
                                src={
                                  getMediaUrl(object.value)
                                }
                                width="90%"
                                alt=""
                              />
                            ) : null}
                          </div>
                        </>
                      )}

                      {object.type === "slider" && (
                        <>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <Button
                              color="error"
                              onClick={() =>
                                delete_stack("media", object, index)
                              }
                            >
                              <HighlightOffIcon />
                            </Button>
                            <IconButton
                              aria-label="move down"
                              onClick={() =>
                                change_stack_position(index, index + 1)
                              }
                            >
                              <KeyboardArrowDownIcon />
                            </IconButton>
                            <IconButton
                              aria-label="move up"
                              onClick={() =>
                                change_stack_position(index, index - 1)
                              }
                            >
                              <KeyboardArrowUpIcon />
                            </IconButton>
                          </div>
                          <div style={{ marginTop: "10px" }}>
                            {object.label}
                            {Array.isArray(object.value) &&
                            object.type === "slider" &&
                            (submitAction === "save" ||
                              submitAction === "update") ? (
                              <Carousel
                                style={{
                                  display: "block",
                                  marginTop: "10px",
                                }}
                              >
                                {object.value.map((url, index) => (
                                  <Paper
                                    key={index}
                                    style={{
                                      width: "100%",
                                      padding: "5px",
                                    }}
                                  >
                                    <img
                                      src={
                                        url.startsWith("http")
                                          ? url
                                          : getMediaUrl(url)
                                      }
                                      width="100%"
                                      alt=""
                                      style={{
                                        width: "100%",
                                        height: "auto",
                                        display: "block",
                                      }}
                                    />
                                  </Paper>
                                ))}
                              </Carousel>
                            ) : null}
                          </div>
                        </>
                      )}

                      {object.type === "hotspot" && (
                        <>
                          <div>
                            <Button
                              color="error"
                              onClick={() =>
                                delete_stack("media", object, index)
                              }
                            >
                              <HighlightOffIcon />
                            </Button>
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                change_stack_position(index, index + 1)
                              }
                            >
                              <KeyboardArrowDownIcon />
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                change_stack_position(index, index - 1)
                              }
                            >
                              <KeyboardArrowUpIcon />
                            </IconButton>
                          </div>
                          <div>
                            {object.label}
                            {object.value &&
                            object.type === "hotspot" &&
                            submitAction === "save" ? (
                              <img
                                src={getMediaUrl(object.thumbnail)}
                                width="90%"
                                alt=""
                              />
                            ) : object.value &&
                              object.type === "hotspot" &&
                              submitAction === "update" ? (
                              <img
                                src={
                                  getMediaUrl(object.thumbnail)
                                }
                                width="90%"
                                alt=""
                              />
                            ) : null}
                          </div>
                        </>
                      )}

                      {object.type === "audio" && (
                        <>
                          <div>
                            <Button
                              color="error"
                              onClick={() =>
                                delete_stack("media", object, index)
                              }
                            >
                              <HighlightOffIcon />
                            </Button>
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                change_stack_position(index, index + 1)
                              }
                            >
                              <KeyboardArrowDownIcon />
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                change_stack_position(index, index - 1)
                              }
                            >
                              <KeyboardArrowUpIcon />
                            </IconButton>
                          </div>
                          <div>
                            {object.label}
                            {object.value &&
                            object.type === "audio" &&
                            submitAction === "save" ? (
                              <audio controls style={{ width: "90%" }}>
                                <source
                                  src={getMediaUrl(object.value)}
                                />
                              </audio>
                            ) : object.value &&
                              object.type === "audio" &&
                              submitAction === "update" ? (
                              <audio controls style={{ width: "90%" }}>
                                <source
                                  src={
                                    getMediaUrl(object.value)
                                  }
                                />
                              </audio>
                            ) : null}
                          </div>
                        </>
                      )}

                      {object.type === "text-audio" && (
                        <>
                          <div>
                            <Button
                              color="error"
                              onClick={() =>
                                delete_stack("media", object, index)
                              }
                            >
                              <HighlightOffIcon />
                            </Button>
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                change_stack_position(index, index + 1)
                              }
                            >
                              <KeyboardArrowDownIcon />
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                change_stack_position(index, index - 1)
                              }
                            >
                              <KeyboardArrowUpIcon />
                            </IconButton>
                          </div>
                          <div>
                            {object.label}
                            {object.value &&
                            object.type === "text-audio" &&
                            submitAction === "save" ? (
                              <audio controls style={{ width: "90%" }}>
                                <source
                                  src={getMediaUrl(object.value)}
                                />
                              </audio>
                            ) : object.value &&
                              object.type === "text-audio" &&
                              submitAction === "update" ? (
                              <audio controls style={{ width: "90%" }}>
                                <source
                                  src={
                                    getMediaUrl(object.value)
                                  }
                                />
                              </audio>
                            ) : null}
                          </div>
                        </>
                      )}

                      <div key={object._id}>
                        {object.type === "video" && (
                          <div>
                            <div>
                              <Button
                                color="error"
                                onClick={() =>
                                  delete_stack("media", object, index)
                                }
                              >
                                <HighlightOffIcon />
                              </Button>
                              <IconButton
                                aria-label="move down"
                                onClick={() =>
                                  change_stack_position(index, index + 1)
                                }
                              >
                                <KeyboardArrowDownIcon />
                              </IconButton>
                              <IconButton
                                aria-label="move up"
                                onClick={() =>
                                  change_stack_position(index, index - 1)
                                }
                              >
                                <KeyboardArrowUpIcon />
                              </IconButton>
                            </div>
                            <div>
                              {object.label}
                              {object.thumbnail && (
                                <img
                                  src={
                                    getMediaUrl(object.thumbnail)
                                  }
                                  width="90%"
                                  alt=""
                                />
                              )}
                            </div>
                            <div>
                              {object.label}
                              {object.value && (
                                <video
                                  key={`${object._id}-${object.value}`} // Ensure key changes with video source
                                  controls
                                  width="98%"
                                >
                                  <source
                                    src={
                                      getMediaUrl(object.value)
                                    }
                                  />
                                </video>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      {object.type === "youtube" && (
                        <>
                          <div>
                            <Button
                              color="error"
                              onClick={() =>
                                delete_stack("text", object, index)
                              }
                            >
                              <HighlightOffIcon />
                            </Button>
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                change_stack_position(index, index + 1)
                              }
                            >
                              <KeyboardArrowDownIcon />
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                change_stack_position(index, index - 1)
                              }
                            >
                              <KeyboardArrowUpIcon />
                            </IconButton>
                          </div>
                          {object.type === "youtube" && (
                            <>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: object.label,
                                }}
                                style={{ wordWrap: "break-word" }}
                              ></div>
                              <div>
                                <iframe
                                  title="YouTube Video"
                                  width="300"
                                  height="195"
                                  src={`https://www.youtube.com/embed/${object.value}`}
                                  frameborder="0"
                                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                  allowfullscreen
                                ></iframe>
                              </div>
                            </>
                          )}
                        </>
                      )}

                      {object.type === "rearrangement" && (
                        <>
                          <div>
                            <Button
                              color="error"
                              onClick={() =>
                                delete_stack("rearrangement", object, index)
                              }
                            >
                              <HighlightOffIcon />
                            </Button>
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                change_stack_position(index, index + 1)
                              }
                            >
                              <KeyboardArrowDownIcon />
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                change_stack_position(index, index - 1)
                              }
                            >
                              <KeyboardArrowUpIcon />
                            </IconButton>
                          </div>
                          {object.type === "rearrangement" && (
                            <>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: object.label,
                                }}
                                style={{ wordWrap: "break-word" }}
                              ></div>
                              <div>
                                {object.value?.map((wordItem, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      display: "inline-block",
                                      margin: "10px",
                                      padding: "5px",
                                      border: "1px solid #000", // Outline
                                      borderRadius: "5px", // Rounded corners (optional)
                                      minWidth: "50px",
                                      height: "25px",
                                      backgroundColor: getColorByIndex(index),
                                    }}
                                  >
                                    <p
                                      style={{
                                        marginTop: "3%",
                                        textAlign: "center",
                                      }}
                                    >
                                      {wordItem.wordValue}
                                    </p>
                                  </div>
                                ))}
                              </div>
                            </>
                          )}
                        </>
                      )}

                      {object.type === "puzzle" && (
                        <>
                          <div>
                            <Button
                              color="error"
                              onClick={() =>
                                delete_stack("puzzle", object, index)
                              }
                            >
                              <HighlightOffIcon />
                            </Button>
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                change_stack_position(index, index + 1)
                              }
                            >
                              <KeyboardArrowDownIcon />
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                change_stack_position(index, index - 1)
                              }
                            >
                              <KeyboardArrowUpIcon />
                            </IconButton>
                          </div>
                          {object.type === "puzzle" && (
                            <>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: object.label,
                                }}
                                style={{ wordWrap: "break-word" }}
                              ></div>
                              <div>
                                {object.value?.map((wordItem, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      display: "inline-block",
                                      margin: "10px",
                                      padding: "5px",
                                      border: "1px solid #000", // Outline
                                      borderRadius: "5px", // Rounded corners (optional)
                                      minWidth: "50px",
                                      height: "25px",
                                      backgroundColor: getColorByIndex(index),
                                    }}
                                  >
                                    <p
                                      style={{
                                        marginTop: "3%",
                                        textAlign: "center",
                                      }}
                                    >
                                      {wordItem.wordValue}
                                    </p>
                                  </div>
                                ))}
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/**Preview Modal */}
          <Modal open={openPreview} onClose={closePreviewBox}>
            <div
              style={{
                // position: "absolute",
                // top: 0,
                // left: 0,
                width: "100%", // Full width of the viewport
                height: "100%", // Full height of the viewport
                backgroundColor: "white", // You can customize the background color
                overflowY: "auto", // Allow scrolling if the content exceeds the viewport
              }}
            >
              <div
                style={{
                  width: "26%",
                  border: "grey 0.4px solid",
                  marginLeft: "36%",
                  // display: "flex",
                  // flexDirection: "column",
                  // justifyContent: "center",
                  height: "77%",
                  overflowY: "auto", // Change this line
                  marginTop: "5%",
                }}
              >
                {stack.map((object, index) => (
                  <div
                    key={index}
                    style={{
                      padding: "5%",
                    }}
                  >
                    {object.label}
                    {object.type === "text" && (
                      <div
                        className="sun-editor-editable"
                        dangerouslySetInnerHTML={{
                          __html: object.value,
                        }}
                        style={{ width: "94%", padding: 0 }}
                      ></div>
                    )}
                    <div style={{}}>
                      {object.type === "image" && submitAction === "save" ? (
                        <>
                          <img
                            src={
                              getMediaUrl(object.value)
                            }
                            style={{
                              width: "100%",
                              aspectRatio: 30 / 20,
                              zIndex: 0,
                            }}
                            alt=""
                            // onClick={handleHotspotClick}
                          />
                        </>
                      ) : object.type === "image" &&
                        submitAction === "update" ? (
                        <img
                          src={
                            getMediaUrl(object.value)
                          }
                          width="90%"
                          alt=""
                        />
                      ) : null}
                    </div>
                    <div style={{}}>
                      {object.type === "slider" && submitAction === "save" ? (
                        <Carousel
                          style={{
                            display: "block",
                            marginTop: "10px",
                          }}
                        >
                          {object.value.map((url, index) => (
                            <Paper
                              key={index}
                              style={{
                                width: "100%",
                                padding: "5px",
                              }}
                            >
                              <img
                                src={
                                  url.startsWith("http")
                                    ? url
                                    : getMediaUrl(url)
                                }
                                width="100%"
                                alt=""
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  display: "block",
                                }}
                              />
                            </Paper>
                          ))}
                        </Carousel>
                      ) : Array.isArray(object.value) &&
                        object.type === "slider" &&
                        submitAction === "update" ? (
                        <Carousel
                          style={{
                            display: "block",
                            marginTop: "10px",
                          }}
                        >
                          {object.value.map((url, index) => (
                            <Paper
                              key={index}
                              style={{
                                width: "100%",
                                padding: "5px",
                              }}
                            >
                              <img
                                src={url}
                                width="100%"
                                alt=""
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  display: "block",
                                }}
                              />
                            </Paper>
                          ))}
                        </Carousel>
                      ) : null}
                    </div>

                    <div>
                      {object.type === "hotspot" && submitAction === "save" ? (
                        <>
                          <img
                            src={
                              getMediaUrl(object.thumbnail)
                            }
                            style={{
                              width: "100%",
                              aspectRatio: 30 / 20,
                              zIndex: 0,
                            }}
                            alt=""
                            onClick={handleHotspotClick}
                          />
                        </>
                      ) : object.type === "hotspot" &&
                        submitAction === "update" ? (
                        <img
                          src={
                            getMediaUrl(object.thumbnail)
                          }
                          width="90%"
                          alt=""
                        />
                      ) : null}
                    </div>

                    {object.type === "audio" ||
                    (object.type === "text-audio" &&
                      submitAction === "save") ? (
                      <audio controls width="90%">
                        <source
                          src={
                            getMediaUrl(object.value)
                          }
                        />
                      </audio>
                    ) : object.type === "audio" ||
                      (object.type === "text-audio" &&
                        submitAction === "update") ? (
                      <audio controls width="90%">
                        <source
                          src={
                            getMediaUrl(object.value)
                          }
                        />
                      </audio>
                    ) : null}

                    {object.type === "video" && submitAction === "save" ? (
                      <div>
                        {object.type === "video" && object.thumbnail !== "" ? (
                          <>
                            <img
                              src={
                                getMediaUrl(object.thumbnail)
                              }
                              width="87%"
                              alt=""
                            />
                          </>
                        ) : null}
                        <video controls width="98%">
                          <source
                            src={
                              getMediaUrl(object.value)
                            }
                          />
                        </video>
                      </div>
                    ) : object.type === "video" && submitAction === "update" ? (
                      <div>
                        {" "}
                        {object.type === "video" && object.thumbnail !== "" ? (
                          <>
                            <img
                              src={
                                getMediaUrl(object?.thumbnail)
                              }
                              width="87%"
                              alt=""
                            />
                          </>
                        ) : null}
                        <video controls width="98%">
                          <source
                            src={
                              getMediaUrl(object.value)
                            }
                          />
                        </video>
                      </div>
                    ) : null}

                    {object.type === "youtube" && (
                      <>
                        {/* <div
                          dangerouslySetInnerHTML={{
                            __html: object.label,
                          }}
                          style={{ wordWrap: "break-word" }}
                        ></div> */}
                        <div>
                          <iframe
                            title="YouTube Video"
                            width="335"
                            height="195"
                            src={`https://www.youtube.com/embed/${object.value}`}
                            frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                          ></iframe>
                        </div>
                      </>
                    )}

                    {object.type === "rearrangement" && (
                      <>
                        {object.type === "rearrangement" && (
                          <>
                            {/* <div
                              dangerouslySetInnerHTML={{
                                __html: object.label,
                              }}
                              style={{ wordWrap: "break-word" }}
                            ></div> */}
                            <div>
                              {object.value?.map((wordItem, index) => (
                                <div
                                  key={index}
                                  style={{
                                    display: "inline-block",
                                    margin: "10px",
                                    padding: "5px",
                                    border: "1px solid #000", // Outline
                                    borderRadius: "5px", // Rounded corners (optional)
                                    minWidth: "50px",
                                    height: "25px",
                                    backgroundColor: getColorByIndex(index),
                                  }}
                                >
                                  <p
                                    style={{
                                      marginTop: "3%",
                                      textAlign: "center",
                                    }}
                                  >
                                    {wordItem.wordValue}
                                  </p>
                                </div>
                              ))}
                            </div>
                          </>
                        )}
                      </>
                    )}

                    {object.type === "puzzle" && (
                      <>
                        {/* <div
                          dangerouslySetInnerHTML={{
                            __html: object.label,
                          }}
                          style={{ wordWrap: "break-word" }}
                        ></div> */}
                        <div>
                          {object.value?.map((wordItem, index) => (
                            <div
                              key={index}
                              style={{
                                display: "inline-block",
                                margin: "10px",
                                padding: "5px",
                                border: "1px solid #000", // Outline
                                borderRadius: "5px", // Rounded corners (optional)
                                minWidth: "50px",
                                height: "25px",
                                backgroundColor: getColorByIndex(index),
                              }}
                            >
                              <p
                                style={{
                                  marginTop: "3%",
                                  textAlign: "center",
                                }}
                              >
                                {wordItem.wordValue}
                              </p>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                ))}
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  width: "35%",
                  marginLeft: "64%",
                }}
              >
                <Button variant="contained" onClick={closePreviewBox}>
                  Close
                </Button>
                {finalSaving ? (
                  <div style={{}}>
                    <CircularProgress />
                  </div>
                ) : (
                  <Button variant="contained" onClick={save_content}>
                    Save
                  </Button>
                )}
              </div>
            </div>
          </Modal>

          {/* Text Dialog */}
          {/* <Dialog open={showTextDialog} onClose={close_text_dialog} keepMounted fullWidth={true} maxWidth="lg" TransitionComponent={Transition} aria-describedby="text-editor"> */}
          <Dialog
            open={showTextDialog}
            keepMounted
            fullWidth={true}
            maxWidth="lg"
            TransitionComponent={Transition}
            aria-describedby="text-editor"
          >
            <DialogTitle>{"Add Text Content"}</DialogTitle>
            <DialogContent>
              <TextField
                id="title"
                label="Label"
                name="label"
                value={label}
                onChange={(e) => setLabel(e.target.value)}
                size="small"
                autoComplete="label"
                margin="normal"
                required
                autoFocus
                fullWidth
              />
              <div>
                <SunEditor
                  height="200px"
                  setContents={editor1Content}
                  onChange={texteditor_on_change}
                  setOptions={EditorOptions}
                  onPaste={handleEditorPaste}
                />
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={close_text_dialog}>Cancel</Button>
              <Button onClick={add_text_to_stack} variant="contained">
                Add Content
              </Button>
            </DialogActions>
          </Dialog>

          {/** Sentence Rearrangement Modal */}
          <Dialog
            open={rearrangeSentenceModal}
            onClose={close_sentence_rearrangement_modal}
            keepMounted
            fullWidth={true}
            maxWidth="lg"
            TransitionComponent={Transition}
            aria-describedby="text-editor"
          >
            <DialogTitle>
              {"Add a sentence for rearrangement/Puzzle"}
            </DialogTitle>
            <DialogContent>
              <TextField
                id="title"
                label="Label"
                name="label"
                value={label}
                onChange={(e) => setLabel(e.target.value)}
                size="small"
                autoComplete="label"
                margin="normal"
                required
                autoFocus
                fullWidth
              />
              <FormControl margin="normal" fullWidth required>
                <InputLabel id="dropdown-label">Type</InputLabel>
                <Select
                  labelId="type-label"
                  id="type"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                >
                  <MenuItem value={"rearrangement"}>Rearrangement</MenuItem>
                  <MenuItem value={"puzzle"}>Puzzle</MenuItem>
                </Select>
              </FormControl>
              {type && (
                <div>
                  {sentenceRearrangements.map((sentence, index) => (
                    <Grid
                      container
                      spacing={3}
                      style={{ marginTop: "10px" }}
                      key={index}
                    >
                      <Grid item xs={5}>
                        <TextField
                          id="title"
                          label="Add your word"
                          name="sentence"
                          value={sentence.wordValue}
                          onChange={(e) =>
                            handleSentenceRearrangementChange(index, e)
                          }
                          size="small"
                          autoComplete="label"
                          margin="normal"
                          required
                          autoFocus={
                            index === sentenceRearrangements.length - 1
                          }
                          fullWidth
                          variant="outlined"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        {sentenceRearrangements.length > 1 && (
                          <Button
                            onClick={() =>
                              handleRemoveSentenceRearrangement(index)
                            }
                            variant="contained"
                            color="error"
                            style={{ marginRight: "10px" }}
                          >
                            -
                          </Button>
                        )}
                      </Grid>
                    </Grid>
                  ))}
                  <Grid container spacing={3} style={{ marginTop: "10px" }}>
                    <Grid item xs={5} />
                    <Grid
                      item
                      xs={2}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Button
                        onClick={handleAddSentenceRearrangement}
                        variant="contained"
                        color="primary"
                      >
                        +
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={close_sentence_rearrangement_modal}>
                Cancel
              </Button>
              <Button
                onClick={add_rearrange_sentence_to_stack}
                variant="contained"
              >
                Add Content
              </Button>
            </DialogActions>
          </Dialog>

          {/* Media Dialog */}
          <Dialog
            open={showMediaDialog}
            keepMounted
            fullWidth={true}
            maxWidth="lg"
            style={{ width: "40%", marginLeft: "28%" }}
            TransitionComponent={Transition}
            aria-describedby="text-editor"
          >
            {mediaType === "slider/*" ? (
              <>
                <DialogTitle>{"Add Slider Images"}</DialogTitle>
                <DialogContent>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() =>
                      document.getElementById("sliderFileInput").click()
                    }
                  >
                    Add
                  </Button>
                  <input
                    id="sliderFileInput"
                    type="file"
                    accept="image/*"
                    multiple
                    style={{ display: "none" }}
                    key={sliderImages?.length}
                    onChange={handleSliderChange}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      marginTop: "20px",
                    }}
                  >
                    {sliderImages.map((image, index) => (
                      <div
                        key={index}
                        style={{ margin: "10px", position: "relative" }}
                      >
                        <img
                          src={image.src}
                          alt={`Slider ${index}`}
                          width="100px"
                          style={{ display: "block" }}
                        />
                        <IconButton
                          color="inherit"
                          size="small"
                          onClick={() => handleRemoveImage(index)}
                          style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </div>
                    ))}
                  </div>
                </DialogContent>
              </>
            ) : (
              <>
                {" "}
                <DialogTitle>{"Upload Media File"}</DialogTitle>
                <DialogContent>
                  {mediaType === "hotspot/*" ? null : (
                    <TextField
                      id="title"
                      label="Label"
                      name="label"
                      value={label}
                      onChange={(e) => setLabel(e.target.value)}
                      size="small"
                      autoComplete="label"
                      margin="normal"
                      required
                      autoFocus
                      fullWidth
                    />
                  )}

                  {mediaType === "video/*" ? (
                    <div>
                      <h4>Upload Thumbnail</h4>
                      <input
                        type="file"
                        accept={"image/*"}
                        // ref={inputFileRef}
                        id="thumbInput"
                        onChange={thumb_file_on_change}
                      />

                      {thumbnailFile ? (
                        <div>
                          <img
                            src={thumbnailFile}
                            alt="image"
                            style={{
                              height: "180px",
                              width: "80%",
                              marginTop: "40px",
                            }}
                          />
                        </div>
                      ) : null}

                      {selectedFileType === "image" ? (
                        <img
                          src={myFile}
                          alt="image"
                          style={{
                            height: "250px",
                            width: "90%",
                            marginTop: "40px",
                          }}
                        />
                      ) : null}
                    </div>
                  ) : null}

                  <div style={{ marginTop: "15px", paddingBottom: "20px" }}>
                    <input
                      type="file"
                      accept={
                        mediaType === "audio/*" || mediaType === "text-audio/*"
                          ? "audio/*"
                          : mediaType === "hotspot/*" ||
                            mediaType === "slider/*"
                          ? "image/*"
                          : mediaType
                      }
                      id="fileInput"
                      onChange={handleFileChange}
                    />
                    {mediaType === "hotspot/*" &&
                      (console.log("check hotspoty---->", imageName),
                      (
                        <>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-evenly",
                            }}
                          >
                            {imageName?.length > 0 ? (
                              <div className="mobilecontainer">
                                <div style={{ position: "relative" }}>
                                  {imageName?.length > 0 && (
                                    <img
                                      src={myFile}
                                      alt="Your Image"
                                      onClick={handleHotspotClick}
                                      style={{
                                        width: "100%",
                                        aspectRatio: 30 / 20,
                                        zIndex: 0,
                                      }}
                                    />
                                  )}

                                  {/* Render circles for saved values */}
                                  {savedValues.map((value, index) => (
                                    <svg
                                      key={index}
                                      style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        zIndex: 1,
                                        pointerEvents: "none",
                                        width: "100%",
                                        height: "100%",
                                      }}
                                    >
                                      <circle
                                        cx={value.xCordinate}
                                        cy={value.yCordinate}
                                        r={10}
                                        fill="transparent"
                                        stroke="red"
                                        strokeWidth={2}
                                      />
                                    </svg>
                                  ))}

                                  {/* Show clicked coordinates */}
                                  <p
                                    style={{
                                      position: "absolute",
                                      top: `${clickPosition.y}px`,
                                      left: `${clickPosition.x}px`,
                                      zIndex: 1,
                                      color: "red",
                                      fontSize: "30px",
                                    }}
                                  >
                                    Clicked at: {clickPosition.x},{" "}
                                    {clickPosition.y}
                                  </p>

                                  {/* Show circle where clicked */}
                                  <svg
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      zIndex: 1,
                                      pointerEvents: "none",
                                      width: "100%",
                                      height: "100%",
                                    }}
                                  >
                                    <circle
                                      cx={clickPosition.x}
                                      cy={clickPosition.y}
                                      r={10}
                                      fill="transparent"
                                      stroke="red"
                                      strokeWidth={2}
                                    />
                                  </svg>
                                </div>
                              </div>
                            ) : imageName?.length > 0 &&
                              savedValues?.length > 0 ? (
                              <div className="mobilecontainer">
                                <div style={{ position: "relative" }}>
                                  {imageName?.length > 0 && (
                                    <img
                                      src={myFile}
                                      alt="Your Image"
                                      onClick={handleHotspotClick}
                                      style={{
                                        width: "100%",
                                        aspectRatio: 30 / 20,
                                        zIndex: 0,
                                      }}
                                    />
                                  )}

                                  {/* Render circles for saved values */}
                                  {savedValues.map((value, index) => (
                                    <svg
                                      key={index}
                                      style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        zIndex: 1,
                                        pointerEvents: "none",
                                        width: "100%",
                                        height: "100%",
                                      }}
                                    >
                                      <circle
                                        cx={value.xCordinate}
                                        cy={value.yCordinate}
                                        r={10}
                                        fill="transparent"
                                        stroke="red"
                                        strokeWidth={2}
                                      />
                                    </svg>
                                  ))}

                                  {/* Show clicked coordinates */}
                                  <p
                                    style={{
                                      position: "absolute",
                                      top: `${clickPosition.y}px`,
                                      left: `${clickPosition.x}px`,
                                      zIndex: 1,
                                      color: "red",
                                      fontSize: "30px",
                                    }}
                                  >
                                    Clicked at: {clickPosition.x},{" "}
                                    {clickPosition.y}
                                  </p>

                                  {/* Show circle where clicked */}
                                  <svg
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      zIndex: 1,
                                      pointerEvents: "none",
                                      width: "100%",
                                      height: "100%",
                                    }}
                                  >
                                    <circle
                                      cx={clickPosition.x}
                                      cy={clickPosition.y}
                                      r={10}
                                      fill="transparent"
                                      stroke="red"
                                      strokeWidth={2}
                                    />
                                  </svg>
                                </div>
                              </div>
                            ) : null}
                          </div>

                          {/* Saved Values Table */}
                          {savedValues?.length > 0 && (
                            <div style={{ marginTop: "20px" }}>
                              <h3>Saved Values</h3>
                              <TableContainer component={Paper}>
                                <Table>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell>Spot Name</TableCell>
                                      <TableCell>Spot Description</TableCell>
                                      <TableCell>Width (X)</TableCell>
                                      <TableCell>Height (Y)</TableCell>
                                      <TableCell>Actions</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {savedValues.map((value, index) => (
                                      <TableRow key={index}>
                                        <TableCell>{value.spotName}</TableCell>
                                        <TableCell>{value.spotDesc}</TableCell>
                                        <TableCell>
                                          {value.xCordinate}
                                        </TableCell>
                                        <TableCell>
                                          {value.yCordinate}
                                        </TableCell>
                                        <TableCell>
                                          <IconButton
                                            onClick={() =>
                                              handleDeleteClick(index)
                                            }
                                            sx={{ color: "red" }}
                                          >
                                            <DeleteIcon />
                                          </IconButton>
                                          <IconButton
                                            onClick={() =>
                                              handleEditClick(index)
                                            }
                                            sx={{ color: "blue" }}
                                          >
                                            <EditIcon />
                                          </IconButton>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          )}

                          {/* Input Fields */}
                          {imageName?.length > 0 && (
                            <>
                              <InputLabel id="demo-select-small">
                                Instruction
                              </InputLabel>
                              <TextField
                                id="title"
                                label="Label"
                                name="label"
                                value={label}
                                onChange={(e) => setLabel(e.target.value)}
                                size="small"
                                autoComplete="label"
                                margin="normal"
                                required
                                autoFocus
                                fullWidth
                              />

                              <TextField
                                id="spotName"
                                variant="outlined"
                                label="Spot Name"
                                value={inputValues.spotName}
                                onChange={handleInputChange}
                              />

                              <TextField
                                id="spotDesc"
                                variant="outlined"
                                label="Spot Description"
                                value={inputValues.spotDesc}
                                onChange={handleInputChange}
                              />

                              <TextField
                                id="width"
                                label="Width (X)"
                                variant="outlined"
                                value={clickPosition.x}
                                style={{ marginTop: "10px" }}
                              />

                              <TextField
                                id="height"
                                label="Height (Y)"
                                variant="outlined"
                                value={clickPosition.y}
                                style={{ marginTop: "10px" }}
                                InputProps={{ readOnly: true }}
                              />

                              <Button
                                variant="contained"
                                color="primary"
                                onClick={handleAddClick}
                              >
                                {editIndex !== null ? "Save" : "Add"}
                              </Button>
                            </>
                          )}
                        </>
                      ))}
                  </div>

                  {selectedFileType === "image" ? null : selectedFileType ===
                      "audio" || selectedFileType === "text-audio" ? (
                    <audio
                      controls
                      src={myFile}
                      style={{ marginTop: "40px" }}
                    ></audio>
                  ) : selectedFileType === "video" ? (
                    <video
                      controls
                      src={myFile}
                      width={"90%"}
                      height={"250px"}
                      style={{ marginTop: "20px" }}
                    ></video>
                  ) : null}
                </DialogContent>
              </>
            )}

            <DialogActions>
              <Button onClick={close_media_dialog}>Cancel</Button>
              {mediaUploading ? (
                <div style={{}}>
                  <CircularProgress />
                </div>
              ) : (
                <Button onClick={add_media_to_stack} variant="contained">
                  Upload File
                </Button>
              )}
            </DialogActions>
          </Dialog>

          {/* Link Dialog */}
          <Dialog
            open={showLinkDialog}
            keepMounted
            fullWidth={true}
            maxWidth="sm"
            TransitionComponent={Transition}
            aria-describedby="link-editor"
          >
            <DialogTitle>{"Add URL"}</DialogTitle>
            <DialogContent>
              <TextField
                id="linkLabel"
                label="Link Label"
                name="linkLabel"
                value={linkText}
                onChange={(e) => setLinkText(e.target.value)}
                size="small"
                autoComplete="text"
                margin="normal"
                required
                fullWidth
              />
              <TextField
                id="linkUrl"
                label="URL"
                name="linkUrl"
                value={linkUrl}
                onChange={UrlAdded}
                size="small"
                autoComplete="url"
                margin="normal"
                required
                fullWidth
              />
            </DialogContent>
            {youtubeFetching ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            ) : linkUrl &&
              linkUrl.startsWith("https://www.youtube.com/watch?v=") ? (
              <div style={{ paddingLeft: "30px" }}>
                <iframe
                  title="YouTube Video"
                  width="346"
                  height="195"
                  src={`https://www.youtube.com/embed/${linkUrl
                    .split("/")[3]
                    .replace("watch?v=", "")
                    .slice(0, 11)}`}
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            ) : linkUrl && linkUrl.startsWith("https://youtu.be/") ? (
              <div style={{ paddingLeft: "30px" }}>
                <iframe
                  title="YouTube Video"
                  width="346"
                  height="195"
                  src={`https://www.youtube.com/embed/${linkUrl
                    .split("/")[3]
                    .slice(0, 11)}`}
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            ) : null}

            <DialogActions>
              <Button onClick={closeLinkDialog}>Cancel</Button>
              {linkAdding ? (
                <div style={{}}>
                  <CircularProgress />
                </div>
              ) : (
                <Button onClick={addLinkToStack} variant="contained">
                  Add Link
                </Button>
              )}
            </DialogActions>
          </Dialog>

          {/* Alert Dialog */}
          <Dialog
            open={showAlert}
            keepMounted
            fullWidth={true}
            maxWidth="sm"
            TransitionComponent={Transition}
            aria-describedby="alert"
          >
            <DialogTitle>{alertTitle}</DialogTitle>
            <DialogContent>
              <div>{alertText}</div>
            </DialogContent>
            <DialogActions>
              <Button onClick={close_alert}>OK</Button>
            </DialogActions>
          </Dialog>

          {/* Loader */}
          {/* <Loader open={showLoader} progress={progress} /> */}
        </div>
      </Dialog>
    </>
  );
}

export default TemplateMaster;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  height: "100%",
};
